import { HttpHeaders } from '@angular/common/http';

export class HttpHeadersHelper {
  static createHeaders(token?: any): HttpHeaders | { [header: string]: string | string[]; } {
    let headersObject: HttpHeaders = new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Access-Control-Allow-Origin': '*',
      });

      // console.log('createHeaders(): Token: ', token);

      if (token !== undefined && token !== null) {
        // console.log('createHeaders(): Adding token header');
        headersObject = headersObject.append('Authorization', 'Bearer ' + token);
      }

      // console.log('createHeaders(): ', headersObject.keys());

      return headersObject;
    }
}
